import type * as React from 'react';
import { FillTag, OutlineTag } from '@doda/io-react/common';
import type { JobKodawariIconResponse } from '@doda/api-client/aspida/@types';
import {
  KODAWARI_ID_DEADLINE,
  KODAWARI_ID_NEW,
  KODAWARI_TAG_EMPHASIS,
  KODAWARI_TAG_EMPLOYMENT_STATUS,
  KODAWARI_TAG_OTHER_CONDITIONS,
} from '../../constants';
import styles from './index.module.scss';

export interface TagGroupProps {
  /** こだわりアイコンデータ */
  tagList: JobKodawariIconResponse[];
  /** スカウト求人かどうか */
  isScout: boolean;
}

const kodawariIconsToDisplay = new Set(['21', '24', '29', '66', '67']);

/** こだわりタグ */
export const TagGroup = ({ tagList, isScout }: TagGroupProps) => {
  const emphasizedTags: React.JSX.Element[] = [];
  const employmentStatusTags: React.JSX.Element[] = [];
  const otherKodawariTags: React.JSX.Element[] = [];

  tagList.forEach((tag) => {
    switch (tag.key) {
      // 新着・締切間近
      case KODAWARI_TAG_EMPHASIS: {
        if (isScout) break;
        if (tag.kodawariList) {
          tag.kodawariList.forEach((kodawari) => {
            if (kodawari.id === KODAWARI_ID_NEW)
              emphasizedTags.push(
                <FillTag color="red" key={`${tag.key}${kodawari.id}`}>
                  New
                </FillTag>
              );
            if (kodawari.id === KODAWARI_ID_DEADLINE)
              emphasizedTags.push(
                <OutlineTag color="red" key={`${tag.key}${kodawari.id}`}>
                  締切間近
                </OutlineTag>
              );
          });
        }
        break;
      }
      // 雇用形態
      case KODAWARI_TAG_EMPLOYMENT_STATUS: {
        if (tag.kodawariList) {
          tag.kodawariList.forEach((kodawari) => {
            if (kodawari.name)
              employmentStatusTags.push(
                <FillTag color="blue" key={`${tag.key}${kodawari.id}`}>
                  {kodawari.name}
                </FillTag>
              );
          });
        }
        break;
      }
      // その他
      case KODAWARI_TAG_OTHER_CONDITIONS: {
        if (tag.kodawariList) {
          tag.kodawariList.forEach((kodawari) => {
            if (
              kodawari.id &&
              kodawariIconsToDisplay.has(kodawari.id) &&
              kodawari.name
            ) {
              otherKodawariTags.push(
                <OutlineTag color="blue" key={`${tag.key}${kodawari.id}`}>
                  {kodawari.name}
                </OutlineTag>
              );
            }
          });
        }
        break;
      }
      default:
    }
  });

  return (
    <div className={styles['jobSearchDetail-tagGroup']}>
      {[...emphasizedTags, ...employmentStatusTags, ...otherKodawariTags]}
    </div>
  );
};
